module.exports = __webpack_public_path__ + "static/avatar-8409d925b9d08b99cc2c27c158f009cf.jpg";